import { Popover } from '@mantine/core';
import { clsx } from 'clsx';

import classes from './common-popover.module.css';

import type { PopoverProps } from '@mantine/core';

type CommonPopoverProps = Omit<PopoverProps, 'classNames'> & {
  classNames?: Partial<Record<'dropdown' | 'arrow', string>>;
};

/**
 * ADL-styled Mantine Popover surface. Opt-in wrapper rather than a global
 * `theme.components.Popover` override: the global theme's classNames/defaultProps
 * cascade into the internal popovers of Select/Menu/Autocomplete/DatePicker/etc.,
 * so the surface is applied here per-instance instead. Use with the standard
 * `Popover.Target` / `Popover.Dropdown` children.
 */
const ADL_ARROW_SIZE = 8 * Math.SQRT2;

export const CommonPopover = ({ shadow = 'sm', arrowSize = ADL_ARROW_SIZE, classNames, ...props }: CommonPopoverProps) => (
  <Popover
    arrowSize={arrowSize}
    shadow={shadow}
    {...props}
    classNames={{
      dropdown: clsx(classes.dropdown, classNames?.dropdown),
      arrow: clsx(classes.arrow, classNames?.arrow),
    }}
  />
);
